import { makeActionCreator } from '../util/state'
import { CLOSE_SNACKBAR } from '../constants/ActionTypes'

export const closeSnackbar = makeActionCreator(CLOSE_SNACKBAR)


// WEBPACK FOOTER //
// ./actions/Notification.js